export * from './dermatoscope';
export * from './horus-scope-1';
export * from './horus-scope-2';
export * from './otoscope';
export * from './stethoscope';
export * from './exam-camera';
export * from './rnk-stethoscope';
